import { createWebHistory, createRouter } from "vue-router";
const Home = () => import("@/view/MyHome.vue");
const About = () => import("@/view/MyAbout.vue");
const Portfolio = () => import("@/view/MyPortfolio.vue");

const routes = [
  {
    path: "/my-cv",
    name: "Home",
    component: Home,
  },
  {
    path: "/my-cv/about",
    name: "About",
    component: About,
  },
  {
    path: "/my-cv/portfolio",
    name: "Portfolio",
    component: Portfolio,
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;